import { createContext } from "react";
export const StatusContext = createContext({
  data: void 0,
  loading: true,
  error: void 0,
  refetch: () => {
  }
});
